<template lang="pug">
  section.home
    Jumbo
    ColumnBlock.row1
      .cont(slot="left")
        h2 CELEBRANDO LOS 10 AÑOS DE MG EN CHILE
        p Desde el 2008, año en que la marca aterriza en Chile.
        VideoBlock(iframe='<iframe id="vrudo" class="vrudo" src="//rudo.video/vod/bGAyle" width="560" height="315" allowscriptaccess="always" allowfullscreen="true" webkitallowfullscreen="true" frameborder="0" scrolling="no" allow="autoplay; fullscreen" ></iframe>')
      .cont(slot="right")
    ColumnBlock.row2
      .cont(slot="left")

      .cont(slot="right")
        h2 LOS DESAFÍOS DE MG A UNA DÉCADA DE SU REGRESO A CHILE
      p Más presentes que nunca en la retina de los consumidores, en MG celebran los 10 años de su regreso a Chile con cifras históricas de ventas, un amplio catálogo de SUV y la renovación de su icónico MG 3, mientras adelantan a un 2019 que vendrá lleno de sorpresas.
        a(href="https://www.latercera.com/mtonline/noticia/los-desafios-mg/455778/", title="Los desafíos de MG" ).btn-more Ver más
    ColumnBlock.row3
      .cont(slot="left")
        h2 MG: CUANDO LA EMOCIÓN SE TRANSFORMA EN ESTILO
        p Desde los centros de investigación y desarrollo de MG cada día salen nuevas ideas y formas enfocadas en un público cada vez más exigente y conectado.
        a(href="https://www.latercera.com/mtonline/noticia/mg-la-emocion-se-transforma-estilo/455986/", title="title").btn-more Ver más
      .cont(slot="right")

    ViewMore
</template>

<script>
import Jumbo from '@/components/Jumbo'
import Imagen from '@/components/Imagen'
import ViewMore from '@/components/ViewMore'
import VideoBlock from '@/components/VideoBlock'
import ColumnBlock from '@/components/ColumnBlock'

export default {
  components: {
    Jumbo,
    Imagen,
    ViewMore,
    VideoBlock,
    ColumnBlock
  }
}
</script>
<style lang="scss" scoped>
  .btn-more{
    background-color: #ffea00;
    color: black;
    display: inline-block;
    padding: 1rem;
    border-radius: 0;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 3px;
    font-weight: bold;
    margin: 20px 0;
    transition-property: color, background-color;
    transition-timing-function: ease;
    &:hover{
      color: black;
      background-color: white;
    }
  }
  .row1{
    background: linear-gradient(to right, white, transparent), url('~@/assets/mg-bg-1alt.jpg') no-repeat right center;
    background-size: cover;
    color: black;
    h2{
      text-shadow: 1px 1px 1px white;
    }
    @media(max-width: 800px){
      background: linear-gradient(to top, white, transparent), url('~@/assets/mg-bg-1alt.jpg') no-repeat right center;
      padding: 5rem 1rem 1rem;
    }
  }
  .row2{
    background: linear-gradient(to left, white 30%, transparent 60%), url('~@/assets/mg-bg-2.jpg') no-repeat right center;
    background-size: cover;
    color: black;
    h2{
      text-shadow: 1px 1px 1px white;
    }
    @media(max-width: 800px){
      background: linear-gradient(to top, white 40%, transparent 70%), url('~@/assets/mg-bg-2.jpg') no-repeat -50px -200px;
      padding: 12rem 1rem 1rem;
      background-size: auto 100%;
    }
  }
  .row3{
    background: linear-gradient(to right, black, transparent 60%), url('~@/assets/mg-bg-3.jpg') no-repeat right center;
    background-size: cover;
    color: white;
    h2{
      text-shadow: 1px 1px 1px black;
    }
    @media(max-width: 800px){
      padding: 10rem 1rem 1rem;
    }
  }
  .content{
    padding: 4rem 1rem;
  }
  .block{
    max-width: $maxwidth;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .block-wide{
    max-width: $overwidth;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .paragraph-dropcap{
    text-indent: 0;
    &:first-letter {
      float: left;
      text-transform: uppercase;
      font-weight: 900;
      font-family: 'cap', sans-serif;
      font-size: 640%;
      text-transform: uppercase;
      line-height: 90%;
      padding-right: 8px;
      margin-left: -6px;
    }
  }

  .block-special{
    max-width: $uberwidth;
    margin: 0 auto;
    position: relative;
    .text{
      position: absolute;
      bottom: 0;
      right: 0;
      max-width: 33%;
      background-color: rgba(0,0,0,0.6);
      color: white;
      padding: 2rem;
      text-align: right;
      @media (max-width: 800px){
        max-width: none;
      }
      h3{
        font-weight: 600;
        line-height: 100%;
        letter-spacing: -3px;
        font-family: 'col', sans-serif;
        text-shadow: 1px 1px 1px black;
        @include fluid-type(360px,
          1440px,
          48px,
          72px);
        color: white;
      }
    }
  }
</style>

